import { TRole } from '../pages/auth/interfaces';
import { menuConfigItems } from '../constants/menuConfigItems';

const {
  profile,
  vendorProducts,
  products,
  orders,
  users,
  legal,
  settings,
  catalog,
  blog,
  guestBlog,
  tariffs,
  productDashboard,
  // companies,
  // vendorUsers,
  vendorCompany,
  catalogForUser,
  chats,
  // tenders,
  buyersTenders,
  vendorsTenders,
  // addTender,
  // allTenders,
  buyersDocuments,
  buyersOrders,
  usersManager,
  shifts,
  statistic,
  vendorRequests,
  buyerRequests,
  buyerCompany,
  finance,
  operatorOrders,
  transactions,
} = menuConfigItems;

// const getDefaultMenu = () => ({
//   header: {
//     self: {},
//     items: [],
//   },
//   aside: {
//     self: {},
//     items: [vendorsTenders, catalogForUser, profile, blog],
//   },
// });

const getManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      // orders,
      users,
      // tariffs,
      // legal,
      
    ],
  },
});

const getAdminMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      orders,
      // productDashboard,
      // shifts,
      // products,
      users,
      tariffs,
      finance,
      settings,
      legal,
      // blog,
      // chats,
      // statistic,
    ],
  },
});

const getOperatorMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      operatorOrders,
    ],
  },
});

const getCashierMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      transactions,
    ],
  },
});

const getVendorMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      // vendorProducts,
      // productDashboard,
      // vendorsTenders,
      // buyersDocuments,
      // vendorCompany,
      // blog,
      // chats,
      // statistic,
      // vendorRequests,
    ],
  },
});

const getBuyerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      // buyersOrders,
      // buyersTenders,
      buyerCompany,
      catalogForUser,
      guestBlog,
      buyerRequests,
    ],
  },
});

const getGuestMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      // catalog,
      // guestBlog
    ],
  },
});

const getContentManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [catalog, orders, users],
  },
});

const getMenuConfig = (userRoles: TRole[] = ['ROLE_BUYER'], isAuthorized?: boolean) => {
  if (isAuthorized) {
    if (userRoles === undefined) {
      return getGuestMenu();
    }
    if (userRoles[0] === 'ROLE_ADMIN') {
      return getAdminMenu();
    }
    if (userRoles[0] === 'ROLE_MANAGER') {
      return getManagerMenu();
    }
    if (userRoles[0] === 'ROLE_VENDOR') {
      return getVendorMenu();
    }
    if (userRoles[0] === 'ROLE_BUYER') {
      return getGuestMenu();
    }
    if (userRoles[0] === 'ROLE_VENDOR_STAFF') {
      return getGuestMenu();
    }
    if (userRoles[0] === 'ROLE_BUYER_STAFF') {
      return getGuestMenu();
    }
    // if (userRoles[0] === 'ROLE_CONTENT_MANAGER') {
    //   return getGuestMenu();
    // }
    if (userRoles[0] === 'ROLE_ORDER_OPERATOR') {
      return getOperatorMenu();
    }
    if (userRoles[0] === 'ROLE_CASHIER') {
      return getCashierMenu();
    }
  } else {
    return getGuestMenu();
  }
};

export default getMenuConfig;
